/**
 * Öffentliche Schnittstelle für die Spam-Mails (unverändert: getSpamData() -> { emails }).
 *
 * Die Daten selbst liegen seit dem Umbau in mail/<sprache>/<episode>.js und laufen in
 * mail/index.js zusammen. Hier steht bewusst kein Inhalt mehr.
 */
import { getAllSpam } from './mail'

export function getSpamData() {
    return { emails: getAllSpam() }
}
